/*
  Marcel Afters, Find Your Edit v3 (28 Sep 2026). Used by sections/ma-find-your-edit.liquid.
  - Six multi-select questions (who, eve, pal, cat, week, vibe) + a fit profile (height, weight, top size + fit, waist,
    length, bottom size + leg, shoe size US/EU, her: top length + dress size).
  - Size layer: assets/ma-fye-sizes.json = each product's REAL size chart (garment cm, built by build_sizes.py from the
    product descriptions). Body measurements (from sizes, or height + weight) + fit preference -> a size per product;
    products that don't stock that size are dropped; the card shows "Your size: L" with that variant preselected.
  - "Where should we send your edit?" posts Shopify's native customer (newsletter) form before the reveal:
    contact[first_name], contact[email], contact[accepts_marketing] (unticked by default) and every answer as fye-* tags
    in contact[tags] (phone, SMS consent, birthday month and city go in tags too). Nothing is emailed from here.
  - Pulls published, in-stock products from /collections/<h>?view=fye-feed (never graphic), scores all selections,
    filters to the chosen sizes, keeps category caps, gender and palette rules.
  - Shareable: ?e=<base64url answers> (no personal data). v1 codes (?e=her.dinner.easy.light.work.dressed) still open.
*/
(function () {
  'use strict';
  if (window.__maFye) return;
  window.__maFye = true;

  var VALID = {
    who: ['her', 'him', 'unisex'], eve: ['dinner', 'late', 'culture', 'home', 'training'],
    pal: ['white', 'black', 'grey', 'sand', 'brown', 'navy', 'softblue', 'green', 'blush'],
    cat: ['tees', 'sweats', 'zips', 'knit', 'shirts', 'trousers', 'shorts', 'denim', 'dresses', 'tanks', 'athletics', 'shoes'],
    week: ['everyday', 'work', 'travel', 'training', 'away', 'weekends'], vibe: ['day', 'dressed', 'night', 'sport']
  };
  var KEYS = ['who', 'eve', 'pal', 'cat', 'week', 'vibe'];
  var PV = { ts: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'], bs: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'], ft: ['fitted', 'regular', 'relaxed', 'oversized'],
    fb: ['slim', 'straight', 'relaxed', 'wide'], tl: ['cropped', 'hip', 'long'], ins: ['short', 'regular', 'long'], ds: ['0', '2', '4', '6', '8', '10', '12', '14', '16'], pg: ['her', 'him'], su: ['usw', 'usm', 'eu'] };
  var PNUM = ['h', 'w', 'waist', 'shoe']; /* cm, kg, in, EU x2 */
  var OPTIONAL = { cat: 1, prof: 1 };
  var MULTI_PF = { ft: 1, fb: 1 }; /* top fit + bottom leg fit are multi-select: sizing should suit any chosen fit */
  var STORE_KEY = 'fye:last3';

  /* ---------- scoring tables ---------- */
  var TRAIN = { athletics: 7, activewear: 6, 'fabric-performance': 5, 'sports-bra': 5, leggings: 5, shorts: 3, sneaker: 5, 'quarter-zip': 2, compression: 4, 'bike-shorts': 4, 'coll:athletics': 5 };
  var W = {
    eve: {
      dinner: { polo: 6, shirt: 5, dressy: 6, 'coll:dressed': 6, pants: 3, trousers: 4, 'straight-leg': 3, pleated: 3, loafer: 6, derby: 5, oxford: 5, monk: 5, mule: 4, pump: 5, slingback: 5, 'mary-jane': 3, dress: 6, 'midi-dress': 4, knit: 4, sweater: 3, 'long-sleeve': 2 },
      late: { 'coll:after-dark': 7, dress: 5, 'mini-dress': 5, 'black-dress': 6, black: 3, tank: 2, 'fit-fitted': 2, boot: 5, chelsea: 5, loafer: 3, pump: 4, slingback: 4, jacket: 4, bomber: 4, dressy: 2 },
      culture: { dressy: 5, shirt: 4, polo: 4, knit: 5, sweater: 3, cardigan: 3, trousers: 3, pants: 2, loafer: 5, mule: 3, 'coll:dressed': 4, dress: 4, 'long-sleeve': 2, 'quarter-zip': 2 },
      home: { hoodie: 5, 'zip-hoodie': 3, sweatshirt: 5, sweatpants: 5, joggers: 5, waffle: 4, 'french-terry': 4, fleece: 4, slipper: 5, slide: 4, 'weight-400gsm-plus': 3, 'weight-heavyweight': 2, crewneck: 2 },
      training: TRAIN
    },
    fit: {
      close: { 'fit-fitted': 7, fitted: 3, 'fit-cropped': 3, 'baby-tee': 4, compression: 3, leggings: 3, ribbed: 2 },
      true: { 'fit-classic': 7, 'fit-straight': 4, classic: 2, 'straight-leg': 3 },
      relaxed: { 'fit-relaxed': 7, relaxed: 3, 'drop-shoulder': 2 },
      roomy: { 'fit-oversized-boxy': 7, 'fit-oversized': 6, 'fit-boxy': 6, boxy: 3, oversized: 3, 'drop-shoulder': 4 },
      cropped: { 'fit-cropped': 7, cropped: 4, 'crop-top': 4, 'baby-tee': 2 }
    },
    fitb: {
      slim: { slim: 5, tapered: 4, 'fit-fitted': 4, leggings: 2, skinny: 4 },
      straight: { 'straight-leg': 6, 'fit-straight': 5, 'fit-classic': 3, straight: 3 },
      relaxed: { 'fit-relaxed': 6, relaxed: 3, barrel: 3, loose: 3 },
      wide: { 'wide-leg': 6, wide: 4, barrel: 4, flare: 3, 'fit-oversized': 3, baggy: 3 }
    },
    week: {
      everyday: { tee: 3, 't-shirt': 3, hoodie: 3, sweatpants: 2, 'weight-heavyweight': 3, sneaker: 4, 'slip-on': 3, 'most-wanted': 5 },
      work: { polo: 6, shirt: 5, 'coll:dressed': 4, pants: 4, trousers: 4, 'long-sleeve': 3, knit: 4, 'quarter-zip': 4, sweater: 3, cardigan: 3, loafer: 5, derby: 4, oxford: 4, dressy: 4 },
      travel: { 'zip-hoodie': 6, 'zip-up': 5, 'quarter-zip': 4, sweatpants: 4, joggers: 4, 'set-eligible': 2, 'slip-on': 4, sneaker: 3, loafer: 2, jacket: 3, 'weight-midweight': 2 },
      training: TRAIN,
      away: { shorts: 5, tank: 4, 'tank-top': 4, sandal: 5, slide: 4, mule: 3, 'weight-lightweight': 4, 'weight-midweight': 2, tee: 2, dress: 3, polo: 2 },
      weekends: { hoodie: 4, sweatshirt: 3, joggers: 4, sweatpants: 4, 'zip-hoodie': 3, tee: 2, sneaker: 4, 'slip-on': 3, slide: 2, shorts: 2, waffle: 2 }
    },
    vibe: {
      day: { 'fit-relaxed': 2, tee: 2, sweatpants: 2, sneaker: 3, 'slip-on': 2, 'set-eligible': 2, 'zip-hoodie': 2, 'most-wanted': 2 },
      dressed: { polo: 4, shirt: 4, pants: 3, trousers: 3, loafer: 4, derby: 3, dressy: 4, knit: 3, 'long-sleeve': 2, 'coll:dressed': 3 },
      night: { black: 3, dress: 4, 'coll:after-dark': 4, boot: 3, chelsea: 3, loafer: 2, 'fit-fitted': 2, tank: 2, pump: 2 },
      sport: { athletics: 5, activewear: 4, sneaker: 3, 'fabric-performance': 3, shorts: 2, 'coll:athletics': 3 }
    }
  };
  var PENALTY = { frayed: -3, 'snow-wash': -2, 'wash-snow-wash': -1, 'raw-edge': -1 };

  /* colour families (order matters: off-palette first, compounds before plain) */
  var FAM = [
    ['off', /\b(red|purple|yellow|orange|mustard|carmine|watermelon|klein|royal|plum|wine|burgundy|gold|silver|colorful|multi|lake|mint|champagne|dark apricot)\b/],
    ['blush', /\b(pink|blush|rose)\b/],
    ['green', /\b(green|olive|sage|moss|army)\b/],
    ['navy', /\b(navy|dark blue|ink blue|indigo|midnight)\b/],
    ['softblue', /\b(blue|denim|jeans)\b/],
    ['brown', /\b(coffee|brown|espresso|cocoa|mocha|chocolate)\b/],
    ['sand', /\b(oat|sand|khaki|beige|camel|almond|tan|taupe|apricot|milk tea|hemp|nude)\b/],
    ['white', /\b(white|bone|cream|ivory|lucent)\b/],
    ['black', /\b(black|pirate|batik)\b/],
    ['grey', /\b(gr[ae]y|charcoal|carbon|ash|cement|graphite|stone|smoke)\b/]
  ];
  var NEAR = { white: ['grey', 'sand'], black: ['grey', 'navy'], grey: ['black', 'white'], sand: ['white', 'brown'], brown: ['sand', 'black'], navy: ['black', 'softblue'], softblue: ['navy', 'white'], green: ['sand', 'grey'], blush: ['white', 'sand'] };
  var SWATCH = { white: '#f4f1ea', black: '#161616', grey: '#8d8b88', sand: '#d9cbb2', brown: '#5a4332', navy: '#1e2a4a', softblue: '#9fb2c8', green: '#6b7155', blush: '#e2c7bf' };

  var CAT = {
    'T-Shirt': 'tee', 'Long Sleeve': 'tee', 'Tank Top': 'tank', Tank: 'tank', Polo: 'top', Shirt: 'top',
    Hoodie: 'layer', 'Zip Hoodie': 'layer', Sweatshirt: 'layer', 'Crewneck Sweatshirt': 'layer', 'Mock Neck Sweatshirt': 'layer',
    'Quarter-Zip': 'layer', Sweater: 'layer', Cardigan: 'layer', Jacket: 'outer',
    Sweatpants: 'bottom', Joggers: 'bottom', Pants: 'bottom', 'Track Pants': 'bottom', 'Yoga Pants': 'bottom', Leggings: 'bottom', Shorts: 'bottom', Skirt: 'bottom',
    Dress: 'dress', 'Sports Bra': 'bra', Shoes: 'shoe'
  };
  var CAP = { tee: 3, tank: 2, top: 3, layer: 4, outer: 2, bottom: 4, dress: 3, bra: 1, shoe: 3, other: 2 };
  function isAth(p) { return !!(p.tok.athletics || p.tok.activewear || p.tok['coll:athletics'] || p.cat === 'bra' || p.tok.leggings); }
  var CATS = {
    tees: function (p) { return p.cat === 'tee'; },
    sweats: function (p) { return /^(Hoodie|Sweatshirt|Crewneck Sweatshirt|Mock Neck Sweatshirt)$/.test(p.y); },
    zips: function (p) { return p.y === 'Zip Hoodie' || p.y === 'Quarter-Zip' || !!(p.tok['zip-up'] || p.tok['zip-hoodie'] || p.tok['quarter-zip']); },
    knit: function (p) { return p.y === 'Sweater' || p.y === 'Cardigan' || !!p.tok.knit || /\bknit\b/i.test(p.t); },
    shirts: function (p) { return p.cat === 'top'; },
    trousers: function (p) { return /^(Pants|Sweatpants|Joggers|Track Pants)$/.test(p.y) && !CATS.denim(p); },
    shorts: function (p) { return p.y === 'Shorts'; },
    denim: function (p) { return !!(p.tok.denim || p.tok.jeans || p.tok['coll:denim']); },
    dresses: function (p) { return p.cat === 'dress' || p.y === 'Skirt'; },
    tanks: function (p) { return p.cat === 'tank'; },
    athletics: isAth,
    shoes: function (p) { return p.cat === 'shoe'; }
  };
  var CAT_OF = { tees: 'tee', sweats: 'layer', zips: 'layer', knit: 'layer', shirts: 'top', trousers: 'bottom', shorts: 'bottom', denim: 'bottom', dresses: 'dress', tanks: 'tank', shoes: 'shoe' };

  var LABEL = {
    eve: { dinner: 'For dinner', late: 'For late nights', culture: 'For a long lunch', home: 'For evenings in', training: 'For training' },
    fit: { close: 'Close fit', true: 'True to size', relaxed: 'Relaxed fit', roomy: 'Roomy fit', cropped: 'Cropped' },
    week: { everyday: 'Every day', work: 'Work to dinner', travel: 'For travel', training: 'For training', away: 'Weekends away', weekends: 'Slow weekends' },
    vibe: { day: 'Daylight', dressed: 'Dressed', night: 'After dark', sport: 'Training' }
  };
  var FITLAB = { 't:fitted': 'Fitted', 't:regular': 'Regular fit', 't:relaxed': 'Relaxed fit', 't:oversized': 'Oversized', 'b:slim': 'Slim leg', 'b:straight': 'Straight leg', 'b:relaxed': 'Relaxed leg', 'b:wide': 'Wide leg' };
  var PAL_TXT = { white: 'white', black: 'black', grey: 'grey', sand: 'oat and sand', brown: 'espresso', navy: 'navy', softblue: 'soft blue', green: 'olive', blush: 'blush' };
  var FIT_TXT = { fitted: 'cut close', regular: 'true to size', relaxed: 'cut relaxed', oversized: 'cut roomy' };
  var EVE_TXT = { dinner: 'long dinners', late: 'late nights', culture: 'long lunches', home: 'evenings in', training: 'early starts' };
  var NUM = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty'];

  function fam(name) {
    var s = String(name || '').toLowerCase().split(' with ')[0].split('/')[0];
    for (var i = 0; i < FAM.length; i++) if (FAM[i][1].test(s)) return FAM[i][0];
    return '';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; u = u.replace(/([?&])width=\d+/, '$1width=' + w); return u.indexOf('//') === 0 ? 'https:' + u : u; }
  function base(t) { return String(t).toLowerCase().replace(/marcel afters|women[’']?s|men[’']?s|unisex|(light|dark) tones|— dark|- dark|\bdark\b|\blight\b/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function list(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function normSize(s) { s = String(s || '').toUpperCase().replace(/\s+/g, ''); return s === 'XXL' ? '2XL' : s === 'XXXL' ? '3XL' : s === 'XXS' ? '2XS' : s; }
  function slug(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40); }
  var ALT_AMBIG = /^part of the look|^look\b/;
  var ALT_M = /^(a )?man\b|^men\b|^two men|^big and tall/, ALT_W = /^(a )?woman\b|^women\b|^two women/, ALT_DUO = /^(two people|three people|four people|a group|a man and a woman)/;

  function gender(p) {
    var g = p.tags, t = p.t.toLowerCase();
    if (/\bwomen[’']?s\b/.test(t)) return 'W';
    if (/\bmen[’']?s\b/.test(t)) return 'M';
    if (g['gender-women']) return 'W';
    if (g['gender-men']) return 'M';
    if (g['gender-unisex'] || g.unisex) return 'U';
    if (g['shoes-her']) return 'W';
    if (g['shoes-him']) return 'M';
    if (g.women && !g.men) return 'W';
    if (g.men && !g.women) return 'M';
    return 'U';
  }

  /* ---------- feed ---------- */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function getPage(h, pg, tries) {
    return fetch(ROOT + 'collections/' + encodeURIComponent(h) + '?view=fye-feed&page=' + pg, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); })
      .catch(function () { return (tries || 0) < 2 ? new Promise(function (res) { setTimeout(function () { res(getPage(h, pg, (tries || 0) + 1)); }, 900 + 900 * (tries || 0)); }) : null; });
  }
  function getColl(h) {
    return getPage(h, 1).then(function (d) {
      if (!d) return [];
      var more = [];
      for (var i = 2; i <= Math.min(d.pgs || 1, 6); i++) more.push(getPage(h, i));
      return Promise.all(more).then(function (rest) { return [d].concat(rest.filter(Boolean)); });
    });
  }
  function loadFeed(handles) {
    return Promise.all(handles.map(getColl)).then(function (lists) {
      var by = {}, pos = 0;
      lists.forEach(function (pages, li) {
        pages.forEach(function (d) {
          (d.p || []).forEach(function (x) {
            var p = by[x.h];
            if (!p) {
              var tags = {};
              String(x.g || '').split('|').forEach(function (t) { if (t) tags[t] = 1; });
              if (tags.graphic) return;
              var z = {};
              String(x.z || '').split('|').forEach(function (s) { if (s) z[normSize(s)] = 1; });
              p = by[x.h] = { h: x.h, t: x.t, y: x.y, tags: tags, i: x.i, a: x.a || '', j: x.j, k: x.k || [], z: z, coll: {}, pos: li === 0 ? pos++ : 9999 };
            }
            p.coll[d.c] = 1;
          });
        });
      });
      var out = Object.keys(by).map(function (k) { return by[k]; });
      out.forEach(function (p) {
        var tok = {};
        Object.keys(p.tags).forEach(function (t) { tok[t] = 1; });
        Object.keys(p.coll).forEach(function (c) { tok['coll:' + c] = 1; });
        var y = String(p.y || '').toLowerCase();
        tok[y.replace(/\s+/g, '-')] = 1;
        y.split(/\s+/).forEach(function (w) { if (w) tok[w] = 1; });
        if (y === 't-shirt') tok.tee = 1;
        p.tok = tok; p.cat = CAT[p.y] || 'other'; p.g = gender(p); p.base = base(p.t);
        p.sg = p.cat === 'shoe' ? 'shoe' : p.cat === 'bottom' ? 'bottom' : 'top';
      });
      return { list: out, essentialsLen: pos };
    });
  }

  /* ---------- ranking ---------- */
  function sum(tok, table) { var s = 0, k; for (k in table) if (tok[k]) s += table[k]; return s; }
  function blend(tok, dim, sel) {
    var best = 0, bestK = null, tot = 0;
    (sel || []).forEach(function (v) { var x = sum(tok, W[dim][v] || {}); tot += x; if (x > best) { best = x; bestK = v; } });
    return { s: best + 0.3 * (tot - best), k: bestK, by: sel };
  }
  /* ---------- size layer ---------- */
  var SIZES = {};
  var ORDERS = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var CHEST = { M: { XS: 84, S: 92, M: 100, L: 108, XL: 116, '2XL': 124, '3XL': 132 }, W: { XS: 80, S: 86, M: 92, L: 100, XL: 108, '2XL': 116, '3XL': 124 } };
  var WAIST = { M: { XS: 70, S: 76, M: 82, L: 90, XL: 98, '2XL': 106, '3XL': 114 }, W: { XS: 62, S: 67, M: 72, L: 80, XL: 88, '2XL': 96, '3XL': 104 } };
  var DRESS = { '0': 'XS', '2': 'XS', '4': 'S', '6': 'S', '8': 'M', '10': 'M', '12': 'L', '14': 'L', '16': 'XL' };
  var EASE_T = { fitted: 4, regular: 10, relaxed: 14, oversized: 18 };   /* cm over the chest, regular cuts */
  var EASE_BOXY = { fitted: 14, regular: 22, relaxed: 24, oversized: 26 }; /* boxy cuts already carry the room: oversized never sizes up further */
  var EASE_B = { slim: 4, straight: 10, relaxed: 16, wide: 24 };      /* cm over the hip */
  function profOn(P) { return !!(P && (P.h || P.ts || P.bs || P.waist || P.ds || P.shoe)); }
  function labelFor(map, v) { var b = null, d = 1e9; Object.keys(map).forEach(function (k) { var x = Math.abs(map[k] - v); if (x < d) { d = x; b = k; } }); return b; }
  function step(label, delta) { var i = ORDERS.indexOf(label); return i < 0 ? label : ORDERS[Math.max(0, Math.min(ORDERS.length - 1, i + delta))]; }
  function body(P, g) {
    var h = P.h || 0, kg = P.w || 0, bmi = h && kg ? kg / Math.pow(h / 100, 2) : 0, b = {};
    var chestEst = !kg ? 0 : g === 'W' ? 56 + 0.55 * kg + (h ? (h - 165) * 0.08 : 0) : 50 + 0.62 * kg + (h ? (h - 178) * 0.1 : 0);
    void bmi;
    var ts = P.ts || (g === 'W' && P.ds && DRESS[P.ds]) || '';
    b.chest = ts ? CHEST[g][ts] : chestEst || (h ? (g === 'W' ? 86 + (h - 165) * 0.3 : 98 + (h - 178) * 0.3) : 0);
    var waistEst = !kg ? 0 : g === 'W' ? 0.45 * kg + 44 : 0.5 * kg + 42;
    b.waist = P.waist ? P.waist * 2.54 : P.bs ? WAIST[g][P.bs] : waistEst || (ts ? WAIST[g][ts] : 0);
    b.hip = b.waist ? b.waist + (g === 'W' ? 24 : 10) : 0;
    b.h = h || (g === 'W' ? 165 : 178);
    b.tall = h >= 188;
    return b;
  }
  /* A size for this product from its own chart (or the customer's size when there is no chart). null = no data to size it. */
  function recSize(p, A) {
    var P = A.prof || {}; if (!profOn(P)) return null;
    var her = A.who.indexOf('her') > -1, him = A.who.indexOf('him') > -1;
    if (her && him && P.pg && p.g !== 'U' && ((P.pg === 'her') !== (p.g === 'W'))) return null; /* the partner's pieces: not sized */
    var g = p.g === 'W' ? 'W' : p.g === 'M' ? 'M' : P.pg === 'him' ? 'M' : P.pg === 'her' ? 'W' : her && !him ? 'W' : 'M';
    if (p.cat === 'shoe') { if (!P.shoe) return null; var eu = String(Math.round(P.shoe)); return { size: eu, stock: !!p.z[eu], pen: 0 }; }
    var b = body(P, g), ch = SIZES[p.h], bottom = p.sg === 'bottom', best = null;
    var elastic = /^(Sweatpants|Joggers|Shorts|Leggings|Track Pants|Yoga Pants|Skirt)$/.test(p.y) || !!(p.tok.drawstring || p.tok.elastic || p.tok.jogger || p.tok.joggers);
    var stretchy = !!(p.tok.bodycon || p.tok.ribbed || p.tok['baby-tee'] || p.tok.compression || p.tok['sports-bra'] || /\b(bodycon|ribbed|baby|tight|slim)\b/i.test(p.t));
    if (bottom ? !b.waist : !b.chest) return null;
    var stated = bottom ? P.bs : (p.cat === 'dress' && P.ds ? DRESS[P.ds] : P.ts);
    var ref = function (i) { var v = CHEST[g][normSize(ch.s[i])]; return v ? ch.c[i] - v : null; };
    var isStretch = !bottom && ch && ch.c && (stretchy || (ref(0) !== null && ref(0) < -2));
    var isBoxy = !bottom && ch && ch.c && !isStretch && ((ref(1) !== null && ref(1) >= 18) || p.tok['fit-oversized'] || p.tok['fit-oversized-boxy'] || p.tok['fit-boxy'] || p.tok.boxy || p.tok['drop-shoulder']);
    if (stated && isStretch) return { size: stated, stock: !!p.z[stated], pen: 0, chart: 0 };
    /* top fit + bottom leg fit are multi-select: a size is judged against whichever chosen fit it suits best */
    var ftArr = (P.ft && P.ft.length) ? P.ft : ['regular'], fbArr = (P.fb && P.fb.length) ? P.fb : ['straight'];
    var minOf = function (vals) { return Math.min.apply(null, vals); };
    if (ch) ch.s.forEach(function (s, i) {
      var sc = 0, pen = 0;
      if (bottom) {
        if (!ch.w && !ch.h) return;
        if (ch.w) sc += 1.3 * Math.abs(ch.w[i] - (elastic ? b.waist - 10 : b.waist + 2)); /* elastic waists measure ~10 cm under the body; fixed waists ~2 cm over */
        if (ch.h) sc += 0.35 * minOf(fbArr.map(function (v) { return Math.abs((ch.h[i] - b.hip) - EASE_B[v]); }));
        if (ch.l && (P.ins === 'long' || b.tall) && ch.l[i] < b.h * 0.58 - 6 && !(p.tok.joggers || p.tok.jogger || p.tok.tapered || p.y === 'Shorts' || p.y === 'Leggings')) pen += 8;
        if (ch.l && P.ins === 'short' && ch.l[i] > b.h * 0.58 + 6 && p.y !== 'Shorts') sc += 2;
      } else {
        if (!ch.c) return;
        if (isStretch || p.cat === 'dress') { sc += Math.abs((ch.c[i] - b.chest) - (isStretch ? -16 : 6)); }
        else { var EMap = isBoxy ? EASE_BOXY : EASE_T; sc += minOf(ftArr.map(function (v) { return Math.abs((ch.c[i] - b.chest) - EMap[v]); })); }
        if (ch.l && p.cat !== 'dress' && P.tl !== 'cropped') {
          var short = b.h * (P.tl === 'long' ? 0.44 : 0.40) - ch.l[i];
          if (short > 4) { sc += (short - 4) * (b.tall ? 1.5 : 0.8); if (b.tall) pen = 6; }
        }
      }
      if (!best || sc < best.sc) best = { size: s, sc: sc, pen: pen, chart: 1 };
    });
    if (best && best.sc > 14) return { size: best.size, stock: false, pen: 0, chart: 1, nofit: 1 }; /* nothing in the range fits them */
    if (!best) {
      var lab = bottom ? (P.bs || labelFor(WAIST[g], b.waist)) : (P.ts || (g === 'W' && P.ds && DRESS[P.ds]) || labelFor(CHEST[g], b.chest));
      if (!bottom) {
        var boxy = p.tok['fit-oversized'] || p.tok['fit-oversized-boxy'] || p.tok['fit-boxy'] || p.tok.boxy || p.tok.oversized;
        if (ftArr.indexOf('oversized') > -1 && !boxy) lab = step(lab, 1);   /* oversized among the chosen fits, from a regular cut: one up */
        if (ftArr.indexOf('fitted') > -1 && boxy && ftArr.indexOf('oversized') < 0) lab = step(lab, -1); /* fitted only, from a boxy cut: one down */
        if (b.tall && !boxy && !p.tok['drop-shoulder']) lab = step(lab, 1);
      }
      best = { size: lab, pen: 0, chart: 0 };
    }
    best.size = normSize(best.size); best.stock = !!p.z[best.size];
    return best;
  }
  /* All qualifying rows (not capped/deduped): used by rank() for the classic edit, and by the reveal
     page (top ten, chapters, full grid) which needs a much bigger pool than rank()'s 20-item cap. */
  function scoreRows(feed, A) {
    var who = A.who || [], her = who.indexOf('her') > -1, him = who.indexOf('him') > -1, uni = who.indexOf('unisex') > -1;
    if (!her && !him && !uni) { her = him = uni = true; }
    var pals = A.pal && A.pal.length ? A.pal : ['white', 'black', 'grey', 'sand', 'navy'];
    var cats = A.cat || [];
    var sporty = (A.eve || []).indexOf('training') > -1 || (A.week || []).indexOf('training') > -1 || (A.vibe || []).indexOf('sport') > -1 || cats.indexOf('athletics') > -1;
    var rows = [];
    feed.list.forEach(function (p) {
      var alt = p.a.toLowerCase();
      if (p.g === 'W' && !her) return;
      if (p.g === 'M' && !him) return;
      if (!him && (ALT_M.test(alt) || (p.g === 'U' && ALT_AMBIG.test(alt)))) return;
      if (!her && (ALT_W.test(alt) || (p.g === 'U' && ALT_AMBIG.test(alt)))) return;
      if (!her && (p.cat === 'dress' || p.tok.skirt || p.tok['sports-bra'])) return;
      if (!p.i || !p.k.length) return;
      var rec = recSize(p, A);
      if (rec && !rec.stock) return; /* doesn't stock their size */
      var catHit = cats.filter(function (c) { return CATS[c] && CATS[c](p); });
      if (cats.length && !catHit.length) return;
      var pick = null, near = null, any = null, byFam = {};
      for (var pi = 0; pi < pals.length; pi++) {
        for (var ci = 0; ci < p.k.length; ci++) { if (fam(p.k[ci][0]) === pals[pi] && !(p.cat === 'layer' && /apricot/i.test(p.k[ci][0]))) { byFam[pals[pi]] = p.k[ci]; if (!pick) pick = p.k[ci]; break; } }
      }
      p.k.forEach(function (c) {
        var f = fam(c[0]);
        if (f === 'off' || (!f && c[0]) || (f === 'blush' && !her)) return;
        if (p.cat === 'layer' && /apricot/i.test(c[0])) return; /* house rule: never feature apricot on hoodies or sweatshirts */
        if (!near && pals.some(function (x) { return (NEAR[x] || []).indexOf(f) > -1; })) near = c;
        if (!any) any = c;
      });
      var col = pick || near || any;
      if (!col) return;
      var e = blend(p.tok, 'eve', A.eve), wk = blend(p.tok, 'week', A.week), vb = blend(p.tok, 'vibe', A.vibe);
      var P = A.prof || {}, ft = { s: 0, k: null };
      if (p.cat === 'shoe') ft.s = 7;
      else if (p.sg === 'bottom') {
        var fbArr = (P.fb && P.fb.length) ? P.fb : ['straight'], bestFb = { s: -1, v: null };
        fbArr.forEach(function (v) { var s = sum(p.tok, W.fitb[v] || {}); if (s > bestFb.s) { bestFb.s = s; bestFb.v = v; } });
        ft.s = bestFb.s; ft.k = bestFb.v ? 'b:' + bestFb.v : null;
      } else {
        var FMAP = { fitted: 'close', regular: 'true', relaxed: 'relaxed', oversized: 'roomy' };
        var ftArr2 = (P.ft && P.ft.length) ? P.ft : ['regular'], bestFt = { s: -1, v: null };
        ftArr2.forEach(function (v) { var s = sum(p.tok, W.fit[FMAP[v]] || {}); if (s > bestFt.s) { bestFt.s = s; bestFt.v = v; } });
        ft.s = bestFt.s + (P.tl === 'cropped' ? 0.5 * sum(p.tok, W.fit.cropped) : 0); ft.k = bestFt.v ? 't:' + bestFt.v : null;
      }
      var parts = { pal: pick ? 12 : near ? 4 : 0, eve: e.s, fit: ft.s, week: wk.s, vibe: vb.s };
      var s = parts.pal + parts.eve + parts.fit + parts.week + parts.vibe + sum(p.tok, PENALTY) + (catHit.length ? 6 : 0);
      if (p.pos < 9999 && feed.essentialsLen) s += 3 * (1 - p.pos / feed.essentialsLen);
      if (p.tok['most-wanted']) s += 2;
      if (!sporty && isAth(p)) s -= 12;
      if (her && !him && p.g === 'W') s += 5;
      if (him && !her && p.g === 'M') s += 5;
      if (uni && p.g === 'U') s += 3;
      if (uni && ALT_DUO.test(alt)) s += 5;
      if (her && !him && ALT_W.test(alt)) s += 2;
      if (him && !her && ALT_M.test(alt)) s += 2;
      if (pals.indexOf('blush') < 0 && fam(col[0]) === 'blush') s -= 4;
      if (rec) s -= rec.pen;
      if (P.h >= 188 && p.sg !== 'shoe' && (p.tok['drop-shoulder'] || p.tok.longline || p.tok['fit-oversized'] || p.tok['fit-oversized-boxy'])) s += 5; /* tall: longer, drop-shoulder cuts (Prince pilot rule) */
      rows.push({ p: p, s: s, col: col, byFam: byFam, rec: rec, parts: parts, keys: { eve: e.k, week: wk.k, fit: ft.k, vibe: vb.k }, exact: !!pick, catHit: catHit });
    });
    rows.sort(function (a, b) { return b.s - a.s; });
    rows.meta = { her: her, him: him, uni: uni, pals: pals, cats: cats, sporty: sporty };
    return rows;
  }
  function rank(feed, A, count) {
    var rows = scoreRows(feed, A), her = rows.meta.her, him = rows.meta.him, cats = rows.meta.cats, pals = rows.meta.pals, sporty = rows.meta.sporty;
    var chosen = [], used = {}, cc = {}, gcount = { W: 0, M: 0, U: 0 };
    var cap = {}; Object.keys(CAP).forEach(function (k) { cap[k] = CAP[k]; });
    cats.forEach(function (c) { if (CAT_OF[c]) cap[CAT_OF[c]] = Math.max(cap[CAT_OF[c]], cats.length <= 2 ? 8 : 5); });
    if (cats.indexOf('athletics') > -1) { cap.bottom = Math.max(cap.bottom, 5); cap.bra = 2; }
    var gmax = Math.round(count * 0.4);
    function ok(r) {
      if (used[r.p.h] || used['b:' + r.p.base]) return false;
      if ((cc[r.p.cat] || 0) >= (cap[r.p.cat] || 2)) return false;
      if (her && him && r.p.g !== 'U' && gcount[r.p.g] >= gmax) return false;
      return true;
    }
    var famUse = {};
    function take(r) {
      var fams = Object.keys(r.byFam);
      if (fams.length > 1) { fams.sort(function (a, b) { return (famUse[a] || 0) - (famUse[b] || 0) || pals.indexOf(a) - pals.indexOf(b); }); r.col = r.byFam[fams[0]]; }
      var f0 = fam(r.col[0]); famUse[f0] = (famUse[f0] || 0) + 1;
      chosen.push(r); used[r.p.h] = 1; used['b:' + r.p.base] = 1; cc[r.p.cat] = (cc[r.p.cat] || 0) + 1; gcount[r.p.g]++; }
    function best(filter) {
      var top = null, topS = -1e9;
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (r.s <= topS) break;
        if (!ok(r) || (filter && !filter(r))) continue;
        var adj = r.s - 5 * (cc[r.p.cat] || 0);
        if (adj > topS) { topS = adj; top = r; }
      }
      return top;
    }
    var floor = (rows.length ? rows[0].s : 0) * 0.35;
    var MIN = [];
    if (her && him) MIN.push([3, function (x) { return x.p.g === 'W'; }], [3, function (x) { return x.p.g === 'M'; }]);
    cats.forEach(function (c) { MIN.push([2, function (x) { return x.catHit.indexOf(c) > -1; }, 0.5]); });
    (A.eve || []).forEach(function (v) { MIN.push([1, function (x) { return sum(x.p.tok, W.eve[v]) >= 5; }]); });
    (A.week || []).forEach(function (v) { MIN.push([1, function (x) { return sum(x.p.tok, W.week[v]) >= 5; }]); });
    if (!cats.length) {
      MIN.push([2, function (x) { return x.p.cat === 'shoe' && x.parts.eve + x.parts.week + x.parts.vibe >= 3; }], [2, function (x) { return x.p.cat === 'bottom'; }], [2, function (x) { return x.p.cat === 'layer'; }]);
      if (sporty) MIN.push([3, function (x) { return isAth(x.p); }]);
    }
    MIN.forEach(function (m) { var fl = floor * (m[2] || 1); for (var n = 0; n < m[0]; n++) { var r = best(function (x) { return x.s >= fl && m[1](x); }); if (r) take(r); } });
    while (chosen.length < count) { var r = best(); if (!r || (r.s < floor && chosen.length >= 12)) break; take(r); }
    chosen.sort(function (a, b) { return b.s - a.s; });
    chosen = chosen.slice(0, Math.min(20, Math.max(count, 12)));
    for (var i = 1; i < chosen.length; i++) {
      if (chosen[i].p.cat === chosen[i - 1].p.cat) {
        for (var j = i + 1; j < chosen.length; j++) if (chosen[j].p.cat !== chosen[i - 1].p.cat) { var t = chosen[i]; chosen[i] = chosen[j]; chosen[j] = t; break; }
      }
    }
    return chosen;
  }
  function reason(r) {
    var topK = null, topV = 3;
    ['eve', 'week', 'fit', 'vibe'].forEach(function (k) { if (r.parts[k] > topV && r.keys[k]) { topV = r.parts[k]; topK = k; } });
    if (topK === 'fit') return FITLAB[r.keys.fit] || 'Your fit';
    if (topK) return LABEL[topK][r.keys[topK]];
    return r.exact ? 'Your colours' : 'From the house';
  }

  /* ---------- capture, sent in the background so the reveal never waits on Shopify (hCaptcha can otherwise
     dead-end a real navigation). No page nav, mode:'no-cors' so a captcha-challenge response is never rendered;
     on a network failure it is queued in localStorage and gets exactly one retry, on the next page load. */
  var CAP_QUEUE_KEY = 'fye:captureQueue';
  function postToShopify(action, payload) {
    return fetch(action, { method: 'POST', mode: 'no-cors', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams(payload).toString() });
  }
  function queueCapture(action, payload) {
    var q = store(CAP_QUEUE_KEY) || [];
    q.push({ action: action, payload: payload, t: Date.now() });
    store(CAP_QUEUE_KEY, q.slice(-5));
  }
  function flushCaptureQueue() {
    var q = store(CAP_QUEUE_KEY) || [];
    if (!q.length) return;
    store(CAP_QUEUE_KEY, []); /* clear first: each queued capture gets exactly one retry */
    q.forEach(function (item) { try { postToShopify(item.action, item.payload).catch(function () {}); } catch (e) {} });
  }
  function postCapture(form) {
    var action = form.getAttribute('action') || (ROOT + 'contact');
    var payload = []; try { new FormData(form).forEach(function (v, k) { payload.push([k, String(v)]); }); } catch (e) {}
    var frame = document.querySelector('[data-capture-frame]');
    if (frame) {
      /* a real <form> POST into a hidden, same-origin iframe carries normal browser semantics (referer, cookies,
         a genuine navigation) which a bare fetch() does not - Shopify's spam check can flatly 403 a fetch that
         looks scripted. The page itself never sees or waits on this. */
      try {
        var prevTarget = form.target;
        form.target = frame.getAttribute('name');
        form.submit();
        form.target = prevTarget || '';
        var onLoad = function () {
          frame.removeEventListener('load', onLoad);
          try {
            var doc = frame.contentDocument, text = doc && doc.body ? doc.body.textContent : '';
            if (doc && (doc.querySelector('.h-captcha, [data-hcaptcha-widget-id], iframe[src*="hcaptcha" i], form#new_customer, form[action*="/contact"]') || /prove you.?re human|verify you are human|captcha/i.test(text))) {
              queueCapture(action, payload); /* a challenge (or the form bounced back): queue it for one retry next visit */
            }
          } catch (e) { /* cross-origin or inaccessible: nothing more we can check, leave it as best-effort */ }
        };
        frame.addEventListener('load', onLoad);
        return;
      } catch (e) {}
    }
    try { postToShopify(action, payload).catch(function () { queueCapture(action, payload); }); } catch (e) { queueCapture(action, payload); }
  }

  /* ---------- cart (same path as ma-sets10x.js) ---------- */
  async function addLine(source, id) {
    var routes = (window.Theme && Theme.routes) || {}, mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: def.promise }));
      } catch (e) { def = null; }
    }
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (n) { if (n.dataset && n.dataset.sectionId) ids.push(n.dataset.sectionId); });
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (ids.length) body.sections = ids.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { cart = await (await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'fye', sourceId: 'fye', itemCount: 1, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    }
    return ok;
  }

  /* ---------- answers <-> share code ---------- */
  function clean(A) {
    var o = {};
    KEYS.forEach(function (k) { o[k] = (A[k] || []).filter(function (v, i, a) { return VALID[k].indexOf(v) > -1 && a.indexOf(v) === i; }).sort(function (x, y) { return VALID[k].indexOf(x) - VALID[k].indexOf(y); }); });
    if (o.who.indexOf('her') < 0) { o.pal = o.pal.filter(function (v) { return v !== 'blush'; }); o.cat = o.cat.filter(function (v) { return v !== 'dresses'; }); }
    var P = A.prof || {}, q = {};
    Object.keys(PV).forEach(function (k) {
      if (MULTI_PF[k]) { var arr = (Array.isArray(P[k]) ? P[k] : (P[k] != null ? [P[k]] : [])).filter(function (v) { return PV[k].indexOf(v) > -1; }); if (arr.length) q[k] = arr; }
      else if (P[k] != null && PV[k].indexOf(String(P[k])) > -1) q[k] = String(P[k]);
    });
    var num = function (v, lo, hi) { v = parseFloat(v); return v >= lo && v <= hi ? v : 0; };
    if (num(P.h, 120, 230)) q.h = Math.round(P.h);
    if (num(P.w, 35, 250)) q.w = Math.round(P.w);
    if (num(P.waist, 22, 56)) q.waist = Math.round(P.waist);
    if (num(P.shoe, 33, 50)) q.shoe = Math.round(P.shoe * 2) / 2;
    if (o.who.indexOf('her') < 0) { delete q.tl; delete q.ds; }
    if (!(o.who.indexOf('her') > -1 && o.who.indexOf('him') > -1)) delete q.pg;
    o.prof = q;
    return o;
  }
  var PORD = ['h', 'w', 'waist', 'shoe', 'ts', 'bs', 'ft', 'fb', 'tl', 'ins', 'ds', 'pg', 'su'];
  /* v3 code: 6 base36 bitmasks + 13 profile values (enums as index+1, 0 = unset), dot separated */
  function encode(A) {
    var m = KEYS.map(function (k) { var x = 0; (A[k] || []).forEach(function (v) { var i = VALID[k].indexOf(v); if (i > -1) x += Math.pow(2, i); }); return x.toString(36); });
    var P = A.prof || {};
    var pr = PORD.map(function (k) {
      if (k === 'shoe') return Math.round((P.shoe || 0) * 2).toString(36);
      if (PNUM.indexOf(k) > -1) return (P[k] || 0).toString(36);
      if (MULTI_PF[k]) { var arr = P[k] || []; return (arr.length ? PV[k].indexOf(arr[0]) + 1 : 0).toString(36); }
      var i = P[k] != null ? PV[k].indexOf(String(P[k])) : -1; return (i + 1).toString(36);
    });
    return m.concat(pr).join('.');
  }
  var V2 = { who: VALID.who, eve: VALID.eve, fit: ['close', 'true', 'relaxed', 'roomy', 'cropped'], pal: VALID.pal, cat: VALID.cat, week: VALID.week, vibe: VALID.vibe,
    top: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'], bottom: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'], shoe: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47'] };
  var FIT2 = { close: 'fitted', true: 'regular', relaxed: 'relaxed', roomy: 'oversized', cropped: 'regular' };
  function bits(m, list) { return list.filter(function (v, i) { return Math.floor(m / Math.pow(2, i)) % 2 === 1; }); }
  function decode(s) {
    if (!s) return null;
    var parts = s.split('.'), A0;
    if (/^[0-9a-z.]+$/.test(s) && parts.length === 19) {
      A0 = {}; KEYS.forEach(function (k, ki) { A0[k] = bits(parseInt(parts[ki], 36) || 0, VALID[k]); });
      var P = {}; PORD.forEach(function (k, i) { var v = parseInt(parts[6 + i], 36) || 0; if (!v) return; if (k === 'shoe') P.shoe = v / 2; else if (PNUM.indexOf(k) > -1) P[k] = v; else if (MULTI_PF[k]) P[k] = [PV[k][v - 1]]; else P[k] = PV[k][v - 1]; });
      A0.prof = P;
    } else if (/^[0-9a-z.]+$/.test(s) && parts.length === 10) { /* v2 link */
      var ks = ['who', 'eve', 'fit', 'pal', 'cat', 'week', 'vibe', 'top', 'bottom', 'shoe'], o = {};
      ks.forEach(function (k, ki) { o[k] = bits(parseInt(parts[ki], 36) || 0, V2[k]); });
      A0 = { who: o.who, eve: o.eve, pal: o.pal, cat: o.cat, week: o.week, vibe: o.vibe, prof: { ft: FIT2[o.fit[0]] ? [FIT2[o.fit[0]]] : undefined, ts: o.top[0], bs: o.bottom[0], shoe: o.shoe[0] ? +o.shoe[0] : 0 } };
    } else if (/^[a-z]+(\.[a-z]+){5}$/.test(s)) { /* v1 link */
      var who = { her: ['her'], him: ['him'], both: ['her', 'him', 'unisex'] }[parts[0]], palm = { light: ['white'], mono: ['black', 'grey'], earth: ['sand', 'brown'], blue: ['navy', 'softblue'], green: ['green'], blush: ['blush'] };
      if (!who) return null;
      A0 = { who: who, eve: [parts[1]], pal: palm[parts[3]] || [], week: [parts[4]], vibe: [parts[5]], prof: { ft: { close: 'fitted', easy: 'regular', roomy: 'oversized' }[parts[2]] ? [{ close: 'fitted', easy: 'regular', roomy: 'oversized' }[parts[2]]] : undefined } };
    } else return null;
    A0 = clean(A0);
    return A0.who.length ? A0 : null;
  }
  function usShoe(P, A) {
    if (!P.shoe) return '';
    var scale = P.su === 'usw' || (P.su === 'eu' && (P.pg === 'her' || (A.who.indexOf('her') > -1 && A.who.indexOf('him') < 0))) ? 'w' : 'm';
    return String(P.shoe - (scale === 'w' ? 31 : 33));
  }
  function tagsFor(A, extra) {
    var t = ['find-your-edit', 'fye-v3'];
    KEYS.forEach(function (k) { A[k].forEach(function (v) { t.push('fye-' + k + '-' + v); }); });
    var P = A.prof || {};
    if (P.h) t.push('fye-h-' + P.h);
    if (P.w) t.push('fye-w-' + P.w);
    if (P.waist) t.push('fye-waist-' + P.waist);
    if (P.ins) t.push('fye-inseam-' + P.ins);
    if (P.shoe) { t.push('fye-shoe-' + usShoe(P, A)); t.push('fye-shoe-eu-' + P.shoe); if (P.su) t.push('fye-shoe-scale-' + P.su); }
    (P.ft || []).forEach(function (v) { t.push('fye-fit-top-' + v); });
    (P.fb || []).forEach(function (v) { t.push('fye-fit-bottom-' + v); });
    if (P.ts) t.push('fye-top-' + P.ts.toLowerCase());
    if (P.bs) t.push('fye-bottom-' + P.bs.toLowerCase());
    if (P.tl) t.push('fye-toplen-' + P.tl);
    if (P.ds) t.push('fye-dress-' + P.ds);
    if (P.pg) t.push('fye-sizefor-' + P.pg);
    Object.keys(extra || {}).forEach(function (k) { if (extra[k]) t.push('fye-' + k + '-' + extra[k]); });
    return t.join(',');
  }

  /* ---------- UI ---------- */
  function init(root) {
    var views = {}; [].forEach.call(root.querySelectorAll('[data-view]'), function (v) { views[v.getAttribute('data-view')] = v; });
    var steps = [].slice.call(root.querySelectorAll('[data-step]'));
    var bar = root.querySelector('.fye-bar i'), back = root.querySelector('[data-back]'), next = root.querySelector('[data-next]');
    var head = root.querySelector('.fye-rh'), pageRowsByHandle = {};
    var baseCount = Math.max(12, Math.min(20, parseInt(root.getAttribute('data-count'), 10) || 16));
    var handles = (root.getAttribute('data-feeds') || 'essentials').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (handles.indexOf('denim') < 0) handles.push('denim');
    var form = root.querySelector('#fye-join');
    /* ft/fb start empty (not pre-seeded with a "phantom" default) - a multi-select chip should always turn ON
       the first time it's clicked. 'regular'/'straight' are applied only as a scoring fallback when nothing is chosen. */
    var DEF = function () { return { ft: [], fb: [], ins: 'regular' }; };
    var A = clean({}), cur = 0, feedP = null, name = '', email = ''; A.prof = DEF();

    var sizesUrl = root.getAttribute('data-sizes');
    function feed() {
      if (!feedP) feedP = Promise.all([loadFeed(handles), sizesUrl ? fetch(sizesUrl).then(function (r) { return r.json(); }).catch(function () { return {}; }) : {}])
        .then(function (x) { SIZES = x[1] || {}; return x[0]; });
      return feedP;
    }
    function stepKey(i) { return steps[i].getAttribute('data-step'); }
    function show(v) { Object.keys(views).forEach(function (k) { views[k].hidden = k !== v; }); }
    function scrollTo(el) { try { var y = el.getBoundingClientRect().top + window.scrollY - 80; if (Math.abs(window.scrollY - y) > 40) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (e) {} }
    function sel(key) { return A[key] || []; }
    function audFilter() {
      var who = A.who.length ? A.who : ['her', 'him', 'unisex'];
      [].forEach.call(root.querySelectorAll('[data-aud]'), function (b) { b.hidden = who.indexOf(b.getAttribute('data-aud')) < 0; });
      [].forEach.call(root.querySelectorAll('[data-need]'), function (b) { b.hidden = A.who.indexOf(b.getAttribute('data-need')) < 0; });
      var both = A.who.indexOf('her') > -1 && A.who.indexOf('him') > -1;
      [].forEach.call(root.querySelectorAll('[data-bothonly]'), function (b) { b.hidden = !both; });
    }
    function paint() {
      steps.forEach(function (s) {
        var key = s.getAttribute('data-step');
        [].forEach.call(s.querySelectorAll('.fye-o'), function (b) {
          var g = b.getAttribute('data-g'), arr = g ? A[g] : A[key];
          b.setAttribute('aria-pressed', String(!!arr && arr.indexOf(b.getAttribute('data-v')) > -1));
        });
      });
      paintProf();
    }
    /* ---------- fit profile ---------- */
    var PR = root.querySelector('[data-step="prof"]'), units = { h: 'imp', w: 'lb' };
    var qp = function (sel) { return PR ? PR.querySelector(sel) : null; };
    function shoeScale() { return A.prof.su || (A.who.indexOf('her') > -1 && A.who.indexOf('him') < 0 ? 'usw' : 'usm'); }
    function shoeOptions() {
      var sc = shoeScale(), sel2 = qp('[data-shoe]'); if (!sel2) return;
      var lo = sc === 'usw' ? 4 : sc === 'usm' ? 6 : 34, hi = sc === 'usw' ? 12 : sc === 'usm' ? 15 : 48, stepv = sc === 'eu' ? 1 : 0.5, off = sc === 'usw' ? 31 : sc === 'usm' ? 33 : 0;
      var html = '<option value="">Size</option>';
      for (var v = lo; v <= hi; v += stepv) html += '<option value="' + (v + off) + '">' + (sc === 'eu' ? 'EU ' : 'US ') + v + '</option>';
      sel2.innerHTML = html;
      if (A.prof.shoe) { var best = null, d = 99; [].forEach.call(sel2.options, function (o) { if (!o.value) return; var x = Math.abs(+o.value - A.prof.shoe); if (x < d) { d = x; best = o.value; } }); if (best) sel2.value = best; }
      [].forEach.call(PR.querySelectorAll('[data-su]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-su') === sc)); });
    }
    function paintProf() {
      if (!PR) return;
      var P = A.prof;
      [].forEach.call(PR.querySelectorAll('.fye-pc[data-pf]'), function (b) {
        var pf = b.getAttribute('data-pf'), v = b.getAttribute('data-v'), pv = P[pf];
        var on = MULTI_PF[pf] ? (pv || []).indexOf(v) > -1 : pv === v;
        b.setAttribute('aria-pressed', String(on));
      });
      [].forEach.call(PR.querySelectorAll('[data-hu]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hu') === units.h)); });
      [].forEach.call(PR.querySelectorAll('[data-unitset]'), function (b) { b.hidden = b.getAttribute('data-unitset') !== units.h; });
      [].forEach.call(PR.querySelectorAll('[data-wu]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-wu') === units.w)); });
      if (P.h) { var tin = Math.round(P.h / 2.54); qp('[data-hft]').value = String(Math.floor(tin / 12)); qp('[data-hin]').value = String(tin % 12); qp('[data-hcm]').value = P.h; }
      var wt = qp('[data-wt]'); wt.placeholder = units.w; if (P.w && !wt.value) wt.value = units.w === 'lb' ? Math.round(P.w / 0.45359237) : P.w;
      if (P.waist) qp('[data-waist]').value = String(P.waist);
      shoeOptions();
      /* "Prefer not to say" chips read as pressed whenever their group is empty - the natural, honest default */
      var skip = { hw: !P.h && !P.w, waist: !P.waist, shoe: !P.shoe, dress: !P.ds };
      [].forEach.call(PR.querySelectorAll('[data-skipgroup]'), function (b) { b.setAttribute('aria-pressed', String(!!skip[b.getAttribute('data-skipgroup')])); });
    }
    function profInput() {
      var P = A.prof;
      if (units.h === 'imp') { var f = +qp('[data-hft]').value, i2 = qp('[data-hin]').value; P.h = f ? Math.round((f * 12 + (+i2 || 0)) * 2.54) : 0; }
      else P.h = Math.round(+qp('[data-hcm]').value) || 0;
      var wv = parseFloat(qp('[data-wt]').value); P.w = wv ? Math.round(units.w === 'lb' ? wv * 0.45359237 : wv) : 0;
      P.waist = +qp('[data-waist]').value || 0;
      P.shoe = +qp('[data-shoe]').value || 0; if (P.shoe) P.su = shoeScale();
      A = clean(A); navState();
      /* keep the "Prefer not to say" chips honest as the customer types, without repainting (and disturbing) the
         inputs they're actively using the way a full paintProf() would */
      var skip = { hw: !A.prof.h && !A.prof.w, waist: !A.prof.waist, shoe: !A.prof.shoe };
      [].forEach.call(PR.querySelectorAll('[data-skipgroup]'), function (b) { var g = b.getAttribute('data-skipgroup'); if (g in skip) b.setAttribute('aria-pressed', String(skip[g])); });
    }
    if (PR) {
      PR.addEventListener('click', function (e) {
        var c = e.target.closest('.fye-pc[data-pf]'), hu = e.target.closest('[data-hu]'), wu = e.target.closest('[data-wu]'), su = e.target.closest('[data-su]'), sk = e.target.closest('[data-skipgroup]');
        if (c) {
          var k = c.getAttribute('data-pf'), v = c.getAttribute('data-v');
          if (MULTI_PF[k]) {
            var arr = (A.prof[k] || []).slice(), i = arr.indexOf(v);
            if (i > -1) arr.splice(i, 1); else arr.push(v);
            if (arr.length) A.prof[k] = arr; else delete A.prof[k];
          } else if (A.prof[k] === v) delete A.prof[k]; else A.prof[k] = v;
          A = clean(A); paintProf(); navState();
        }
        if (hu) { units.h = hu.getAttribute('data-hu'); paintProf(); }
        if (wu) { units.w = wu.getAttribute('data-wu'); qp('[data-wt]').value = ''; paintProf(); }
        if (su) { A.prof.su = su.getAttribute('data-su'); A = clean(A); shoeOptions(); profInput(); }
        if (sk) {
          var g = sk.getAttribute('data-skipgroup');
          if (g === 'hw') { A.prof.h = 0; A.prof.w = 0; qp('[data-hft]').value = ''; qp('[data-hin]').value = ''; qp('[data-hcm]').value = ''; qp('[data-wt]').value = ''; }
          else if (g === 'waist') { A.prof.waist = 0; qp('[data-waist]').value = ''; }
          else if (g === 'shoe') { A.prof.shoe = 0; delete A.prof.su; qp('[data-shoe]').value = ''; }
          else if (g === 'dress') { delete A.prof.ds; }
          A = clean(A); paintProf(); navState();
        }
      });
      PR.addEventListener('change', profInput); PR.addEventListener('input', profInput);
    }
    function navState() {
      var key = stepKey(cur);
      back.hidden = false;
      if (key === 'cap') { next.hidden = true; return; }
      next.hidden = false;
      var n = key === 'prof' ? (profOn(A.prof) ? 1 : 0) : sel(key).length;
      next.disabled = !n && !OPTIONAL[key];
      next.textContent = !n && OPTIONAL[key] ? 'Skip' : (key === 'vibe' ? 'Continue to your edit' : 'Continue');
    }
    function go(i) {
      cur = i;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      bar.style.width = (i / (steps.length - 1) * 100) + '%';
      audFilter(); navState();
      var h = steps[i].querySelector('h2'); if (h) try { h.focus({ preventScroll: true }); } catch (e) {}
      scrollTo(views.quiz);
      if (stepKey(i) === 'cap') { var f = root.querySelector('[data-fname]'); if (f && !f.value) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 300); }
    }
    function count() {
      var extra = A.cat.length + Math.max(0, A.eve.length - 1) + Math.max(0, A.week.length - 1) + (A.who.length > 1 ? 2 : 0);
      return Math.max(12, Math.min(20, baseCount + Math.floor(extra / 2)));
    }

    function cardsHTML(rows, startAt) {
      return rows.map(function (r, i0) {
        var i = (startAt || 0) + i0;
        var p = r.p, c = r.col, href = ROOT + 'products/' + p.h + (c[1] ? '?variant=' + c[1] : '');
        var hover = c[2] && c[2] !== p.i ? c[2] : p.j;
        return '<li class="fye-card" style="--i:' + i0 + '" data-h="' + esc(p.h) + '" data-c="' + esc(c[0]) + '" data-sg="' + p.sg + '" data-cat="' + esc(p.cat) + '"' + (r.rec ? ' data-rec="' + esc(r.rec.size) + '"' : '') + '>' +
          '<a class="fye-card__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' +
          '<span class="fye-card__n">' + (i < 9 ? '0' : '') + (i + 1) + '</span>' +
          '<img src="' + esc(img(p.i, 720)) + '" srcset="' + esc(img(p.i, 400)) + ' 400w, ' + esc(img(p.i, 720)) + ' 720w" sizes="(min-width:1100px) 24vw, (min-width:750px) 32vw, 48vw" alt="" loading="' + (i < 4 ? 'eager' : 'lazy') + '">' +
          (hover ? '<img src="' + esc(img(hover, 720)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="fye-card__t" href="' + esc(href) + '">' + esc(p.t) + '</a>' +
          '<p class="fye-card__why"><i style="background:' + (SWATCH[fam(c[0])] || '#ccc') + '"></i>' + esc(reason(r)) + (c[0] ? ' · ' + esc(c[0]) : '') + '</p>' +
          (r.rec ? '<p class="fye-card__size">Your size: ' + (p.cat === 'shoe' ? 'EU ' : '') + esc(r.rec.size) + '</p>' : '') +
          '<button type="button" class="fye-add" data-add>Add to bag</button></li>';
      }).join('');
    }
    /* preselect the variant in their size (and colour when stocked) for every card in a container */
    function preselectSizes(container) {
      [].forEach.call(container.querySelectorAll('.fye-card[data-rec]'), function (card) {
        fetch(ROOT + 'products/' + card.getAttribute('data-h') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (pr) {
          var ci = -1, si = -1, want = card.getAttribute('data-rec'), col = card.getAttribute('data-c');
          (pr.options || []).forEach(function (o, k) { var n = String(o.name || o).toLowerCase(); if (n.indexOf('colo') > -1) ci = k; else if (n.indexOf('size') > -1) si = k; });
          if (si < 0) return;
          var ok = pr.variants.filter(function (v) { return v.available && normSize(v.options[si]) === want; });
          var v = ok.filter(function (x) { return ci < 0 || x.options[ci] === col; })[0];
          if (!v) v = ok.filter(function (x) { var f = fam(ci > -1 ? x.options[ci] : ''); return A.pal.indexOf(f) > -1; })[0] || ok.filter(function (x) { var f = fam(ci > -1 ? x.options[ci] : ''); return f && f !== 'off'; })[0];
          if (!v) return;
          var href = ROOT + 'products/' + card.getAttribute('data-h') + '?variant=' + v.id;
          [].forEach.call(card.querySelectorAll('a'), function (a) { a.href = href; });
          if (ci > -1 && v.options[ci] !== col) {
            card.setAttribute('data-c', v.options[ci]);
            var why = card.querySelector('.fye-card__why'); if (why) { why.lastChild.textContent = why.lastChild.textContent.replace(/ · .*$/, '') + ' · ' + v.options[ci]; var dot = why.querySelector('i'); if (dot) dot.style.background = SWATCH[fam(v.options[ci])] || '#ccc'; }
          }
          var btn = card.querySelector('[data-add]'); if (btn) { btn.removeAttribute('data-add'); btn.setAttribute('data-vid', v.id); btn.textContent = 'Add ' + (card.getAttribute('data-sg') === 'shoe' ? 'EU ' : '') + want + ' to bag'; }
        }).catch(function () {});
      });
    }
    function renderCards(container, rows, startAt) { container.innerHTML = cardsHTML(rows, startAt); preselectSizes(container); }

    /* ---------- personal page: hero / seen / kpi / top ten / chapters of looks / every piece / close ---------- */
    function kpiGender() {
      var her = A.who.indexOf('her') > -1, him = A.who.indexOf('him') > -1;
      if (A.prof.pg) return A.prof.pg === 'her' ? 'W' : 'M';
      return him && !her ? 'M' : 'W';
    }
    function heightTxt(h) { if (!h) return ''; var tin = Math.round(h / 2.54); return Math.floor(tin / 12) + "'" + (tin % 12) + '" · ' + h + ' cm'; }
    function seenLines(name) {
      var her = A.who.indexOf('her') > -1, him = A.who.indexOf('him') > -1;
      var eve = A.eve.length ? list(A.eve.map(function (v) { return EVE_TXT[v]; })) : 'most evenings';
      var pal = A.pal.length ? list(A.pal.slice(0, 3).map(function (v) { return PAL_TXT[v]; })) : 'a clean, neutral palette';
      var fit = (A.prof.ft && A.prof.ft.length) ? list(A.prof.ft.map(function (v) { return FIT_TXT[v]; })) : 'true to size';
      var out = [];
      out.push((name ? name + ', you' : 'You') + ' told us about ' + eve + (her && him ? ', for both of you' : '') + ', and we built around it.');
      out.push('Your palette leans ' + pal + ', cut ' + fit + '.');
      if (A.week.length && LABEL.week[A.week[0]]) out.push((LABEL.week[A.week[0]] || 'Your week') + ' shaped the rest of the edit.');
      return out.slice(0, 3);
    }
    function kpiHTML(rowsAll) {
      var P = A.prof || {}, g = kpiGender(), items = [];
      var ts = P.ts || (g === 'W' && P.ds && DRESS[P.ds]) || (P.h || P.w ? labelFor(CHEST[g], body(P, g).chest) : '');
      var bs = P.bs || (P.h || P.w ? labelFor(WAIST[g], body(P, g).waist) : '');
      if (ts) items.push({ n: normSize(ts), l: 'Top size' });
      if (bs) items.push({ n: normSize(bs), l: 'Bottom size' });
      if (P.shoe) items.push({ n: 'EU ' + P.shoe, l: 'Shoe size' });
      if (P.h) items.push({ n: heightTxt(P.h), l: 'Height' });
      items.push({ n: (P.ft && P.ft.length) ? list(P.ft.map(function (v) { return FIT_TXT[v]; })) : 'True to size', l: 'How you like it to fit' });
      var sized = rowsAll.filter(function (r) { return r.rec && r.rec.stock; }).length;
      items.push({ n: String(profOn(P) ? sized : rowsAll.length), l: profOn(P) ? 'Pieces in your size' : 'Pieces curated for you' });
      return '<div class="fye-kpi__grid">' + items.map(function (it) { return '<div class="fye-kpi__item"><b class="fye-kpi__n">' + esc(it.n) + '</b><span class="fye-kpi__l">' + esc(it.l) + '</span></div>'; }).join('') + '</div>';
    }
    /* group a pool of rows into look-buckets by category */
    /* The "hero" piece (a top, or a dress) carries the occasion's character, so it is scored against that
       occasion's own vocabulary. Bottoms/layers/shoes are everyday wardrobe basics that pair across occasions,
       so they are drawn from the customer's overall best-scoring, in-stock pieces rather than re-filtered per
       occasion (a "Pants" product type is a fair dinner match; loungewear "Joggers" never scores as a dinner
       bottom even though it is exactly what should complete an "evenings in" look) - filtering bottoms by the
       same narrow vocabulary as the top starved almost every chapter of a pairing. */
    function chapterDefs() {
      var seen = {}, out = [];
      (A.eve || []).forEach(function (v) { var t = LABEL.eve[v]; if (t && !seen[t]) { seen[t] = 1; out.push({ t: t, kind: 'eve', v: v }); } });
      (A.week || []).forEach(function (v) { var t = LABEL.week[v]; if (t && !seen[t]) { seen[t] = 1; out.push({ t: t, kind: 'week', v: v }); } });
      (A.vibe || []).forEach(function (v) { var t = LABEL.vibe[v]; if (t && !seen[t] && out.length < 5) { seen[t] = 1; out.push({ t: t, kind: 'vibe', v: v }); } });
      if (out.length < 3) out.push({ t: 'From the house', kind: 'top', v: null });
      return out.slice(0, 5);
    }
    function chapterScore(r, def) {
      if (def.kind === 'eve') return sum(r.p.tok, W.eve[def.v] || {});
      if (def.kind === 'week') return sum(r.p.tok, W.week[def.v] || {});
      if (def.kind === 'vibe') return sum(r.p.tok, W.vibe[def.v] || {});
      return 0;
    }
    /* up to maxLooks complete outfits from a hero pool (tops+dresses, occasion-scored) plus shared, unfiltered
       bottoms/layers/shoes pools (sorted by overall score). usedTops is shared across chapters so the same hero
       piece never headlines two chapters; bottoms/layers/shoes may repeat across chapters (styling a strong
       trouser two ways is normal) but not twice within the same chapter. */
    function buildLooks(heroPool, bottoms, layers, shoes, usedTops, maxLooks) {
      var looks = [], usedHere = {};
      function pick(arr) { for (var i = 0; i < arr.length; i++) { if (!usedHere[arr[i].p.h]) { usedHere[arr[i].p.h] = 1; return arr[i]; } } return null; }
      heroPool.filter(function (r) { return r.p.cat === 'dress'; }).forEach(function (r) {
        if (looks.length >= maxLooks || usedTops[r.p.h]) return;
        usedTops[r.p.h] = 1; usedHere[r.p.h] = 1;
        var pcs = [r], sh = pick(shoes); if (sh) pcs.push(sh);
        looks.push(pcs);
      });
      var tops = heroPool.filter(function (r) { return r.p.cat !== 'dress'; });
      for (var ti = 0; ti < tops.length && looks.length < maxLooks; ti++) {
        var t = tops[ti]; if (usedTops[t.p.h] || usedHere[t.p.h]) continue;
        var bt = pick(bottoms); if (!bt) break;
        usedTops[t.p.h] = 1; usedHere[t.p.h] = 1;
        var pcs2 = [t, bt];
        if (looks.length % 2 === 0) { var ly = pick(layers); if (ly) pcs2.push(ly); }
        var sh2 = pick(shoes); if (sh2) pcs2.push(sh2);
        looks.push(pcs2);
      }
      return looks;
    }
    function chaptersHTML(rowsAll, usedGlobal) {
      var defs = chapterDefs(), blocks = [], allLooks = [], built = 0;
      var bottoms = rowsAll.filter(function (r) { return r.p.cat === 'bottom'; });
      var layers = rowsAll.filter(function (r) { return r.p.cat === 'layer' || r.p.cat === 'outer'; });
      var shoes = rowsAll.filter(function (r) { return r.p.cat === 'shoe'; });
      var usedTops = {}; Object.keys(usedGlobal).forEach(function (h) { usedTops[h] = 1; });
      function tryDef(def) {
        var heroSrc = rowsAll.filter(function (r) { return !usedTops[r.p.h] && (r.p.cat === 'tee' || r.p.cat === 'top' || r.p.cat === 'tank' || r.p.cat === 'dress'); })
          .map(function (r) { return { r: r, sc: chapterScore(r, def) }; })
          .sort(function (a, b) { return (b.sc - a.sc) || (b.r.s - a.r.s); });
        var scored = heroSrc.filter(function (x) { return x.sc >= 3; });
        var heroPool = (def.kind !== 'top' && scored.length >= 4 ? scored : heroSrc).map(function (x) { return x.r; });
        var looks = buildLooks(heroPool, bottoms, layers, shoes, usedTops, 4);
        if (looks.length < 2) return false;
        var looksHTML = looks.map(function (pcs, li) {
          var media = pcs.map(function (r) { return '<span class="fye-look__thumb"><img src="' + esc(img(r.p.i, 480)) + '" alt="" loading="lazy"></span>'; }).join('');
          var names = list(pcs.map(function (r) { return r.p.t.replace(/^Marcel Afters\s*/i, ''); }));
          return '<li class="fye-look" data-look="' + li + '">' +
            '<div class="fye-look__media">' + media + '</div>' +
            '<p class="fye-look__t">Look ' + (li + 1) + '</p>' +
            '<p class="fye-look__pieces">' + esc(names) + '</p>' +
            '<button type="button" class="fye-add fye-look__add" data-add-look="' + esc(pcs.map(function (r) { return r.p.h; }).join(',')) + '">Add the look</button></li>';
        }).join('');
        blocks.push('<section class="fye-chapter" data-chapter>' +
          '<header class="fye-chapter__h"><h3>' + esc(def.t) + '</h3><p>' + esc(looks.length) + (looks.length === 1 ? ' complete set' : ' complete sets') + ', built from pieces in your size and colours.</p></header>' +
          '<ul class="fye-looks" role="list">' + looksHTML + '</ul></section>');
        allLooks = allLooks.concat(looks);
        return true;
      }
      defs.forEach(function (def) { if (tryDef(def)) built++; });
      /* a narrow category filter can starve occasion-specific chapters of a "hero" top even though plenty of
         bottoms/shoes remain; pad with generic chapters from the same pool rather than ship fewer than 3. */
      var GENERIC = ['More from the house', 'In your colours', 'Easy pieces'];
      for (var gi = 0; built < 3 && gi < GENERIC.length; gi++) {
        if (tryDef({ t: GENERIC[gi], kind: 'top', v: null })) built++; else break;
      }
      return { html: blocks.join(''), looks: allLooks };
    }
    function heroHTML(top, nm) {
      var n = Math.max(3, Math.min(5, top.length)), slides = top.slice(0, n);
      var eve = A.eve.length ? list(A.eve.slice(0, 2).map(function (v) { return EVE_TXT[v]; })) : 'everything in between';
      var pal = A.pal.length ? list(A.pal.slice(0, 2).map(function (v) { return PAL_TXT[v]; })) : 'your colours';
      var figs = slides.map(function (r, i) {
        return '<figure class="fye-hero__slide' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '"' + (i ? ' aria-hidden="true"' : '') + '>' +
          '<img src="' + esc(img(r.p.i, 1400)) + '" srcset="' + esc(img(r.p.i, 800)) + ' 800w, ' + esc(img(r.p.i, 1400)) + ' 1400w" sizes="100vw" alt="' + esc(r.p.t) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '"></figure>';
      }).join('');
      var dots = slides.map(function (r, i) { return '<button type="button" class="fye-hero__dot' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '" aria-label="Look ' + (i + 1) + ' of ' + slides.length + '"></button>'; }).join('');
      return '<div class="fye-hero__stage" data-hero-stage>' + figs +
        (slides.length > 1 ? '<button type="button" class="fye-hero__arrow fye-hero__arrow--l" data-hero-dir="-1" aria-label="Previous look">&lsaquo;</button>' +
          '<button type="button" class="fye-hero__arrow fye-hero__arrow--r" data-hero-dir="1" aria-label="Next look">&rsaquo;</button>' +
          '<div class="fye-hero__dots">' + dots + '</div>' : '') + '</div>' +
        '<div class="fye-hero__copy">' +
        '<p class="fye-k">Your edit</p>' +
        '<h2 class="fye-h">Your edit' + (nm ? ', ' + esc(nm) : '') + '.</h2>' +
        '<p class="fye-l">Built for ' + esc(eve) + ', in ' + esc(pal) + '.</p>' +
        '<div class="fye-hero__cta"><button type="button" class="fye-btn" data-jump="top">See your top ten</button><button type="button" class="fye-btn fye-btn--o" data-jump="chapters">Shop the looks</button></div>' +
        '</div>';
    }
    function wireHero(hero) {
      if (!hero) return;
      var stage = hero.querySelector('[data-hero-stage]'), figs = [].slice.call(hero.querySelectorAll('.fye-hero__slide')), dots = [].slice.call(hero.querySelectorAll('.fye-hero__dot'));
      var i = 0, tm = null, hov = false, rm = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
      if (figs.length < 2) return;
      function show2(k) {
        k = (k + figs.length) % figs.length; if (k === i) return;
        figs[i].classList.remove('is-on'); figs[i].setAttribute('aria-hidden', 'true');
        if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].setAttribute('aria-current', 'false'); }
        i = k;
        figs[i].classList.add('is-on'); figs[i].removeAttribute('aria-hidden');
        if (dots[i]) { dots[i].classList.add('is-on'); dots[i].setAttribute('aria-current', 'true'); }
      }
      function go2(k) { show2(k); sched(); }
      function sched() { clearTimeout(tm); if (rm.matches || hov || document.hidden) return; tm = setTimeout(function () { go2(i + 1); }, 5500); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go2(k); }); });
      [].forEach.call(hero.querySelectorAll('[data-hero-dir]'), function (b) { b.addEventListener('click', function () { go2(i + (+b.getAttribute('data-hero-dir'))); }); });
      hero.addEventListener('mouseenter', function () { hov = true; clearTimeout(tm); });
      hero.addEventListener('mouseleave', function () { hov = false; sched(); });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; clearTimeout(tm); }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go2(i + (dx < 0 ? 1 : -1)); else sched(); x0 = null; }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(tm); else sched(); });
      sched();
    }
    function indexHTML(rowsAll) {
      var CATLABEL = { tee: 'Tees', tank: 'Tanks', top: 'Shirts & polos', layer: 'Layers', outer: 'Outerwear', bottom: 'Bottoms', dress: 'Dresses', shoe: 'Shoes', bra: 'Active', other: 'More' };
      var cats = [], seen = {};
      rowsAll.forEach(function (r) { if (!seen[r.p.cat]) { seen[r.p.cat] = 1; cats.push(r.p.cat); } });
      var chips = '<button type="button" class="fye-idx__chip is-on" data-cat="all">All</button>' + cats.map(function (c) { return '<button type="button" class="fye-idx__chip" data-cat="' + c + '">' + esc(CATLABEL[c] || c) + '</button>'; }).join('');
      return '<div class="fye-idx__filters" role="group" aria-label="Filter by category">' + chips + '</div>' +
        '<p class="fye-idx__count" data-idx-count>' + rowsAll.length + ' pieces in your size and colours</p>' +
        '<ul class="fye-grid fye-idx__grid" role="list" data-idx-grid></ul>';
    }
    function wireIndexFilters(idx) {
      if (!idx) return;
      idx.addEventListener('click', function (e) {
        var chip = e.target.closest('.fye-idx__chip'); if (!chip) return;
        [].forEach.call(idx.querySelectorAll('.fye-idx__chip'), function (c) { c.classList.toggle('is-on', c === chip); });
        var cat = chip.getAttribute('data-cat'), n = 0;
        [].forEach.call(idx.querySelectorAll('.fye-card'), function (card) { var show = cat === 'all' || card.getAttribute('data-cat') === cat; card.hidden = !show; if (show) n++; });
        var c2 = idx.querySelector('[data-idx-count]'); if (c2) c2.textContent = n + ' piece' + (n === 1 ? '' : 's') + ' in your size and colours';
      });
    }
    function closeHTML() {
      return '<div class="fye-close__actions">' +
        '<button type="button" class="fye-btn" data-copy>Share my edit</button>' +
        '<button type="button" class="fye-btn fye-btn--o" data-mail-confirm>Email me my edit</button>' +
        '<button type="button" class="fye-link" data-restart>Start again</button>' +
        '<a class="fye-link" href="/collections/essentials">Back to Essentials</a>' +
        '</div><p class="fye-close__note" data-close-note hidden></p>';
    }
    function resolveVariant(meta) {
      return fetch(ROOT + 'products/' + meta.h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (pr) {
        var ci = -1, si = -1;
        (pr.options || []).forEach(function (o, k) { var n = String(o.name || o).toLowerCase(); if (n.indexOf('colo') > -1) ci = k; else if (n.indexOf('size') > -1) si = k; });
        var vs = pr.variants.filter(function (v) { return v.available && (ci < 0 || v.options[ci] === meta.c); });
        if (!vs.length) vs = pr.variants.filter(function (v) { return v.available; });
        if (!vs.length) return null;
        if (meta.rec && si > -1) { var m = vs.filter(function (v) { return normSize(v.options[si]) === meta.rec; }); if (m.length) vs = m; }
        return vs[0].id;
      }).catch(function () { return null; });
    }
    function addLook(handles, btn) {
      var hs = handles.split(',').filter(Boolean);
      btn.disabled = true; btn.textContent = 'Adding the look…';
      Promise.all(hs.map(function (h) {
        var r = pageRowsByHandle[h];
        return resolveVariant({ h: h, c: r ? r.col[0] : '', rec: r && r.rec ? r.rec.size : null });
      })).then(function (ids) {
        ids = ids.filter(Boolean);
        var chain = Promise.resolve(0);
        ids.forEach(function (id) { chain = chain.then(function (ok) { return addLine(btn, id).then(function (added) { return ok + (added ? 1 : 0); }); }); });
        return chain;
      }).then(function (ok) {
        btn.textContent = ok ? ('Added ' + ok + ' piece' + (ok > 1 ? 's' : '') + ' to bag') : 'Try again';
        btn.classList.toggle('is-done', !!ok);
        setTimeout(function () { btn.disabled = false; if (!ok) btn.textContent = 'Add the look'; }, 2600);
      });
    }
    function renderPersonalPage(rowsAll, top) {
      var page = root.querySelector('[data-page]'); if (!page) return;
      pageRowsByHandle = {}; rowsAll.forEach(function (r) { pageRowsByHandle[r.p.h] = r; });
      var usedGlobal = {}; top.forEach(function (r) { usedGlobal[r.p.h] = 1; });
      var ch = chaptersHTML(rowsAll, usedGlobal);
      page.innerHTML =
        '<section class="fye-hero" data-hero>' + heroHTML(top, name) + '</section>' +
        '<section class="fye-seen"><h2 class="fye-h2">We see you' + (name ? ', ' + esc(name) : '') + '.</h2>' + seenLines(name).map(function (s) { return '<p class="fye-l fye-seen__p">' + esc(s) + '</p>'; }).join('') + '</section>' +
        '<section class="fye-kpi" data-kpi><h2 class="fye-h2">What fits you</h2>' + kpiHTML(rowsAll) + '</section>' +
        '<section class="fye-top" data-top><h2 class="fye-h2">Your top ten</h2><ul class="fye-grid fye-top__grid" role="list" data-top-grid></ul></section>' +
        (ch.html ? '<section class="fye-chapters" data-chapters><h2 class="fye-h2">The looks</h2>' + ch.html + '</section>' : '') +
        '<section class="fye-idx" data-idx><h2 class="fye-h2">Every piece in your size</h2>' + indexHTML(rowsAll) + '</section>' +
        '<section class="fye-close" data-close><h2 class="fye-h2">Keep your edit</h2>' + closeHTML() + '</section>';
      page.hidden = false;
      renderCards(page.querySelector('[data-top-grid]'), top.slice(0, 10));
      renderCards(page.querySelector('[data-idx-grid]'), rowsAll.slice(0, 80));
      wireHero(page.querySelector('[data-hero]'));
      wireIndexFilters(page.querySelector('[data-idx]'));
    }

    function reveal() {
      store(STORE_KEY, { A: A, name: name, email: email });
      try { history.replaceState(null, '', location.pathname + '?e=' + encode(A)); } catch (e) {}
      show('reveal');
      head.classList.remove('is-in');
      var page0 = root.querySelector('[data-page]'); if (page0) page0.hidden = true;
      root.querySelector('[data-err]').hidden = true;
      root.querySelector('[data-loading]').hidden = false;
      root.querySelector('[data-headline]').textContent = 'Choosing your pieces';
      root.querySelector('[data-line]').textContent = '';
      requestAnimationFrame(function () { head.classList.add('is-in'); });
      scrollTo(root);
      var t0 = Date.now();
      feed().then(function (f) {
        var rowsAll = scoreRows(f, A);
        var top = rowsAll.slice(0, Math.max(10, count()));
        if (top.length < 6) throw new Error('thin');
        setTimeout(function () {
          root.querySelector('[data-loading]').hidden = true;
          var h = root.querySelector('[data-headline]');
          h.textContent = name ? 'Your edit, ' + name + '.' : 'Your edit.';
          var her = A.who.indexOf('her') > -1, him = A.who.indexOf('him') > -1;
          var k = root.querySelector('.fye-rh .fye-k'); if (k) k.textContent = her && him ? 'For her and for him' : her ? 'For her' : him ? 'For him' : 'For the two of you';
          root.querySelector('[data-line]').textContent = 'Scroll down. Your edit is ready.';
          renderPersonalPage(rowsAll, top);
          try { h.focus({ preventScroll: true }); } catch (e) {}
          try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('fye_edit_revealed', { answers: encode(A), pieces: top.map(function (r) { return r.p.h; }) }); } catch (e) {}
        }, Math.max(0, 700 - (Date.now() - t0)));
      }).catch(function () {
        root.querySelector('[data-loading]').hidden = true;
        root.querySelector('[data-headline]').textContent = 'Your edit.';
        root.querySelector('[data-err]').hidden = false;
        feedP = null;
      });
    }

    /* events */
    root.querySelector('[data-begin]').addEventListener('click', function () { feed(); show('quiz'); go(0); });
    back.addEventListener('click', function () { if (cur > 0) go(cur - 1); else show('intro'); });
    next.addEventListener('click', function () {
      if (next.disabled) return;
      if (cur < steps.length - 1) go(cur + 1);
    });
    steps.forEach(function (step) {
      step.addEventListener('click', function (e) {
        var b = e.target.closest('.fye-o'); if (!b) return;
        var key = b.getAttribute('data-g') || step.getAttribute('data-step'), v = b.getAttribute('data-v');
        var arr = A[key], i = arr.indexOf(v);
        if (i > -1) arr.splice(i, 1); else arr.push(v);
        if (key === 'who') A = clean(A);
        paint(); audFilter(); navState();
      });
    });

    /* capture: native customer form. Answers + optional fields become fye-* tags; answers kept for the reveal after the redirect. */
    function capError(msg, el) {
      var e = root.querySelector('[data-ferr]'); e.textContent = msg; e.hidden = false;
      if (el) { el.setAttribute('aria-invalid', 'true'); try { el.focus(); } catch (x) {} }
    }
    if (form) form.addEventListener('submit', function (ev) {
      ev.preventDefault(); /* the reveal never depends on Shopify's own round-trip (hCaptcha can otherwise dead-end it) */
      var fn = root.querySelector('[data-fname]'), em = root.querySelector('[data-email]');
      [fn, em].forEach(function (x) { x.removeAttribute('aria-invalid'); });
      name = (fn.value || '').trim().replace(/\s+/g, ' ').slice(0, 60);
      var firstOnly = name.split(' ')[0].slice(0, 24);
      if (!name) return capError('Please add your first name.', fn);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((em.value || '').trim())) return capError('Please add a valid email address - it is the only thing we need to send you your edit.', em);
      var ph = (root.querySelector('[data-phone]').value || '').replace(/[^\d+]/g, '');
      var digits = ph.replace(/\D/g, '');
      var tel = digits.length >= 7 && digits.length <= 15 ? (ph.charAt(0) === '+' ? digits : (digits.length === 10 ? '1' + digits : digits)) : '';
      var sms = root.querySelector('[data-sms]').checked && tel;
      var mkt = root.querySelector('[data-mkt]').checked;
      var extra = { tel: tel, sms: sms ? 'yes' : (tel ? 'no' : ''), bday: root.querySelector('[data-bday]').value, city: slug(root.querySelector('[data-city]').value), email: mkt ? 'yes' : 'no' };
      var tags = tagsFor(A, extra) + ',fye-e-' + encode(A);
      if (mkt) tags += ',newsletter';
      var extraTag = root.getAttribute('data-extra-tag'); if (extraTag) tags += ',' + extraTag;
      if (/^fye-test/i.test((em.value || '').trim())) tags += ',fye-test';
      root.querySelector('[data-tags]').value = tags.split(',').filter(function (t, i, a) { return t && a.indexOf(t) === i; }).join(',');
      email = (em.value || '').trim();
      name = firstOnly;
      store(STORE_KEY, { A: A, name: name, email: email, pending: 0 });
      var sendBtn = root.querySelector('[data-send]'); sendBtn.textContent = 'One moment';
      postCapture(form); /* fire-and-forget in the background; queued + retried once on the next visit if it fails */
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('fye_captured', { answers: encode(A), marketing: mkt, sms: !!sms }); } catch (e) {}
      reveal(); /* immediately, client-side - never waits on Shopify */
    });

    /* one delegated handler covers every dynamically-rendered control on the personal page (hero jumps,
       add-the-look, email/share close actions, restart) plus the classic add-to-bag / size-chooser flow
       for any .fye-card wherever it is rendered (top ten, chapters, or the full index grid). */
    root.addEventListener('click', function (e) {
      var jump = e.target.closest('[data-jump]');
      if (jump) { var tgt = root.querySelector('[data-' + jump.getAttribute('data-jump') + ']'); if (tgt) scrollTo(tgt); return; }
      var addLookBtn = e.target.closest('[data-add-look]');
      if (addLookBtn) { addLook(addLookBtn.getAttribute('data-add-look'), addLookBtn); return; }
      var mailBtn = e.target.closest('[data-mail-confirm]');
      if (mailBtn) {
        var note = root.querySelector('[data-close-note]');
        if (note) { note.hidden = false; note.textContent = email ? ('Sent to ' + email + '. It is already in your inbox.') : 'Your edit is already saved to your details.'; }
        return;
      }
      var restartBtn = e.target.closest('[data-restart]');
      if (restartBtn) { A = clean({}); A.prof = DEF(); paint(); try { history.replaceState(null, '', location.pathname); } catch (er) {} show('quiz'); go(0); return; }
      var copyBtn = e.target.closest('[data-copy]');
      if (copyBtn) {
        var url = location.origin + location.pathname + '?e=' + encode(A);
        var restore = function (t) { setTimeout(function () { copyBtn.textContent = 'Share my edit'; }, t || 2200); };
        var toClipboard = function () {
          var done = function () { copyBtn.textContent = 'Link copied'; restore(); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Your edit', url); copyBtn.textContent = 'Share my edit'; });
          else { window.prompt('Your edit', url); copyBtn.textContent = 'Share my edit'; }
        };
        /* mobile: the native share sheet; desktop (or if it's unavailable/cancelled): clipboard, always with visible confirmation */
        if (navigator.share && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
          navigator.share({ title: 'Your edit, Marcel Afters', url: url }).then(function () { copyBtn.textContent = 'Shared'; restore(1400); }, function (err) {
            if (err && err.name === 'AbortError') { copyBtn.textContent = 'Share my edit'; return; }
            toClipboard();
          });
        } else toClipboard();
        return;
      }
      var addBtn = e.target.closest('[data-add]'), sz = e.target.closest('[data-vid]');
      var card = e.target.closest('.fye-card'); if (!card) return;
      if (sz) {
        sz.disabled = true;
        addLine(sz, sz.getAttribute('data-vid')).then(function (ok) {
          var box = card.querySelector('.fye-sizes') || sz;
          var b = document.createElement('button'); b.type = 'button'; b.className = 'fye-add' + (ok ? ' is-done' : ''); b.setAttribute('data-add', '');
          b.textContent = ok ? 'Added. Add another' : 'Try again';
          box.replaceWith(b);
        });
        return;
      }
      if (!addBtn) return;
      addBtn.disabled = true; addBtn.textContent = 'One moment';
      fetch(ROOT + 'products/' + card.getAttribute('data-h') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (pr) {
        var ci = -1, si = -1;
        (pr.options || []).forEach(function (o, k) { var n = String(o.name || o).toLowerCase(); if (n.indexOf('colo') > -1) ci = k; else if (n.indexOf('size') > -1) si = k; });
        var col = card.getAttribute('data-c'), mine = card.getAttribute('data-rec') ? [card.getAttribute('data-rec')] : [];
        var vs = pr.variants.filter(function (v) { return v.available && (ci < 0 || v.options[ci] === col); });
        if (!vs.length) { addBtn.textContent = 'Sold out in this colour'; return; }
        if (vs.length === 1 && si < 0) { addBtn.disabled = false; addBtn.setAttribute('data-vid', vs[0].id); addBtn.removeAttribute('data-add'); addBtn.click(); return; }
        var box = document.createElement('div'); box.className = 'fye-sizes'; box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'Choose a size');
        box.innerHTML = '<p>Choose a size</p>' + vs.map(function (v) { var s = si > -1 ? v.options[si] : v.title; return '<button type="button" data-vid="' + v.id + '"' + (mine.indexOf(normSize(s)) > -1 ? ' class="is-mine"' : '') + '>' + esc(s) + '</button>'; }).join('');
        addBtn.replaceWith(box);
        var first = box.querySelector('.is-mine') || box.querySelector('button'); if (first) first.focus();
      }).catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add to bag'; });
    });

    /* entry: back from the form, a form error, a shared link, or fresh */
    var q = new URLSearchParams(location.search), stEl = root.querySelector('[data-form-state]');
    var fstate = (stEl && stEl.getAttribute('data-form-state')) || (q.get('customer_posted') === 'true' ? 'ok' : '');
    var saved = store(STORE_KEY) || {};
    var shared = decode(q.get('e'));
    if (fstate && saved.A) {
      A = clean(saved.A); name = String(saved.name || '').trim().split(/\s+/)[0].slice(0, 24); email = String(saved.email || '');
      paint();
      if (fstate === 'ok') { saved.pending = 0; store(STORE_KEY, saved); reveal(); }
      else { show('quiz'); go(steps.length - 1); var fnI = root.querySelector('[data-fname]'); if (fnI && name) fnI.value = name; }
    } else if (shared) {
      A = shared; name = ''; paint(); reveal();
    }
  }

  window.__maFyeApi = { rank: rank, scoreRows: scoreRows, loadFeed: loadFeed, fam: fam, encode: encode, decode: decode, tagsFor: tagsFor, clean: clean, recSize: recSize, setSizes: function (x) { SIZES = x; } };
  function boot() { flushCaptureQueue(); [].forEach.call(document.querySelectorAll('[data-fye]'), function (r) { if (!r.__fye) { r.__fye = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
